import * as React from "react"
import styled from "styled-components"
import { scale, breakpoint } from "../../styles"
import { Image } from "../Image"

interface HeaderLogoProps {
	alt: string
	src: string
}

export const HeaderLogo: React.FC<HeaderLogoProps> = ({ alt, src }) => {
	const HeaderLogoStyled = styled.img`
		width: auto;
		height: ${scale.px(3)};
	`

	return <Image height={24} src={src} alt={alt} />
}
